// extracted by mini-css-extract-plugin
export default {"employer-dashboard-container":"style_employer-dashboard-container__dWd4A","employerDashboardContainer":"style_employer-dashboard-container__dWd4A"};